import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyDiCCuqYVXSL6Y17Os6Ct7bmfaruFe1Xfo",
  authDomain: "ungrief-ed04a.firebaseapp.com",
  projectId: "ungrief-ed04a",
  storageBucket: "ungrief-ed04a.firebasestorage.app",
  messagingSenderId: "653222136468",
  appId: "1:653222136468:web:bbedb0d7948f138ff54281",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
